/*
 * @Author: zhangchaoqiang
 * @LastEditors: Do not edit
 * @LastEditTime: 2022-03-07 14:31:41
 * @FilePath: /gyl-finace-web/src/main.js
 * @Description: Do not edit
 */


import 'babel-polyfill'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './assets/css/gyl-common.css'
import './style/new-gyl-common.less'
import animated from 'animate.css'


import VueDND from 'awe-dnd'
import inc from './components/inc/index'
import axios from './libs/http'
import { dialog, alertMsg } from './libs/fn'
import filters from './libs/filter'
import './libs/auto-size' /*引入基于1920px设计图的rem*/
import echarts from 'echarts';
import cytoscape from "cytoscape"
import directive from './libs/directive'
import moment from 'moment';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
moment.locale('zh-cn')
// import {mixins} from './libs/mixins'
// Vue.mixin(mixins);
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.use(VueDND)
Vue.use(iView)
Vue.use(inc)
Vue.use(echarts)
Vue.use(cytoscape)
Vue.use(animated)
Vue.use(Viewer);

Viewer.setDefaults({
    'button':true,
    'navbar':false,
    'title':false,
    'toolbar':true
})
Vue.prototype.$Message = iView.Message
Vue.prototype.$ajax = axios
Vue.prototype.$Dialog = dialog
Vue.prototype.$alertMsg = alertMsg
Vue.prototype.$echarts = echarts
Vue.prototype.$cytoscape = cytoscape
Vue.prototype.$Loading.config({height:4})
Vue.prototype.$moment = moment



Vue.config.productionTip = false;

export default new Vue({
    'el': '#app',
    router,
    store,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js